<script>
import Form from './Form.vue';
import { matchField } from '@/validation';

export default {
  name: 'ResetPassword',
  extends: Form,

  data() {
    return {
      fields: [
        {
          name: 'newpassword',
          type: 'password',
          label: 'New Password'
        },
        {
          name: 'confirmNewPassword',
          type: 'password',
          label: 'Confirm New Password',
          customValidation: this.matchPassword
        }
      ]
    };
  },

  watch: {
    'formData.password'() {
      this.$refs.confirmNewPassword[0].setFieldError();
    }
  },

  methods: {
    matchPassword(confirmNewPasswordField) {
      return matchField(
        confirmNewPasswordField,
        this.$refs.newpassword[0].$refs.input
      );
    }
  }
};
</script>